const EXECUTION_PERIOD_TIME = 0;
const EXECUTION_DATE = 1;
const CREATION_DATE = 2;

export default { EXECUTION_PERIOD_TIME, EXECUTION_DATE, CREATION_DATE };
